//#region ImportsSection
import React, { useState } from "react";
import Draggable from "react-draggable";
import {
  Button,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import swal from "sweetalert";
import { isUrdu, LoadingSpinner } from "../../constants/const";
import { GetLanguageString } from "../helper/Components";
import ApiHabibProgress from "../config/habibprogress/ApiHabibProgress";
//#endregion ImportsSection
const AddProgressComment = ({ task, onClose, refreshBoard }) => {
  //#region StateSection
  const [comment, setComment] = useState("");

  const [progress] = useState(task);

  const [errors, setErrors] = useState();
  const [loading, setLoading] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  //#endregion StateSection
  //#region functionSection
  const handleDrag = (e, ui) => {
    const { x, y } = position;
    setPosition({ x: x + ui.deltaX, y: y + ui.deltaY });
  };

  const validate = () => {
    let temp = {};
    temp.comment = comment ? (
      ""
    ) : (
      <GetLanguageString props="common_field_required_error" />
    );

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setComment(value);
    setErrors({
      ...errors,
      [name]: "",
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setLoading(true);
      ApiHabibProgress()
        .AddHabibProgressComment({
          Comment: comment,
          HabibId: progress.habibId,
          HabibProgressId: progress.id,
        })

        .then((res) => {
          if (typeof refreshBoard === "function") {
            refreshBoard();
          }

          onClose(false);
          setLoading(false);
        })
        .catch((err) => {
          swal({
            title: err,
            icon: "error",
            buttons: "OK",
          });
          setLoading(false);
        });
    }
  };
  //#endregion functionSection

  return (
    <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
      <Modal isOpen={true} className="inmodal" autoFocus={false}>
        <ModalHeader className="modal-title" tag="h4">
          <GetLanguageString props="member_member_detail_course_comment" />
        </ModalHeader>
        {!loading ? (
          <Form onSubmit={handleSubmit}>
            <ModalBody>
              <FormGroup>
                <Label>
                  <GetLanguageString props="member_member_detail_course_comment" />
                </Label>
                <Input
                  autoFocus
                  type="text"
                  name="comment"
                  className={isUrdu(comment) ? "no-drag ur" : "no-drag"}
                  onChange={handleInputChange}
                  {...(errors?.comment && { invalid: true })}
                />
                {errors?.comment && (
                  <FormFeedback>
                    <h4>{errors?.comment}</h4>
                  </FormFeedback>
                )}
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button color="white" onClick={() => onClose(false)}>
                <GetLanguageString props="common_cancel" />
              </Button>
              <Button color="primary" type="submit">
                <GetLanguageString props="common_save" />
              </Button>{" "}
            </ModalFooter>
          </Form>
        ) : (
          LoadingSpinner()
        )}
      </Modal>
    </Draggable>
  );
};

export default AddProgressComment;
